import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "inline-flex items-center space-x-2 text-gray-400"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", null, "Fetching NFTs...", -1)
const _hoisted_3 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_4 = { key: 2 }
const _hoisted_5 = { class: "grid gap-8 grid-cols-1 sm:grid-cols-2 md:grid-cols-3 mb-8" }

import {
  computed, ref, toRefs, watchEffect,
} from 'vue';
import { Account, AccountPresenter } from '@/models';
import { getAccountRoute } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  props: {
    account: null,
    presenter: null
  },
  setup(__props: any) {

const props = __props as {
  account: Account,
  presenter: AccountPresenter,
}



const { account } = toRefs(props);

// Load tokens from the account.
watchEffect(() => account.value.tokens.load());
const nfts = computed(() => account.value.tokens.all.filter(({ isNft, amount }) => isNft && !amount.isZero()));
const loading = computed(() => account.value.tokens.loading);

// Pagination.
const perPage = 6;
const page = ref(1);
const paginatedNfts = computed(() => nfts.value.slice(
  (page.value - 1) * perPage,
  page.value * perPage,
));

return (_ctx: any,_cache: any) => {
  const _component_icon_loading = _resolveComponent("icon-loading")!
  const _component_nft_card = _resolveComponent("nft-card")!
  const _component_fetch_multiple_accounts = _resolveComponent("fetch-multiple-accounts")!
  const _component_base_pagination = _resolveComponent("base-pagination")!

  return (_unref(loading))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_component_icon_loading, { class: "w-5 h-5 text-gray-300 animate-spin" }),
        _hoisted_2
      ]))
    : (_unref(nfts).length === 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, " This wallet has no NFTs. "))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("ul", _hoisted_5, [
            _createVNode(_component_fetch_multiple_accounts, {
              addresses: _unref(paginatedNfts).map(nft => nft.metadata)
            }, {
              default: _withCtx(({ accounts }) => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(accounts, ({ account, loading }, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: account?.publicKey?.toBase58() ?? index
                  }, [
                    _createVNode(_component_nft_card, {
                      metadata: account?.metadata ?? {},
                      loading: loading,
                      error: !account?.metadata,
                      to: account?.decodedData?.mint ? _unref(getAccountRoute)(account.decodedData.mint) : null
                    }, null, 8, ["metadata", "loading", "error", "to"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["addresses"])
          ]),
          _createVNode(_component_base_pagination, {
            class: "mt-8",
            page: page.value,
            "onUpdate:page": _cache[0] || (_cache[0] = ($event: any) => ((page).value = $event)),
            perPage: perPage,
            total: _unref(nfts).length
          }, null, 8, ["page", "total"])
        ]))
}
}

})